// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-truncatedphotoprintslist_container__1fhgc","restOfPhotos":"idt-truncatedphotoprintslist_restofphotos__1ibac"};